// extracted by mini-css-extract-plugin
module.exports = {"inline":"SpendStatusesLoading_inline__3KGRl","text":"SpendStatusesLoading_text__3p2NV"};